import React, { Component } from "react";
import { Button, Copy, Icon, Row } from "app/NativeComponents/common";
class Resource extends Component {
  render() {
    const { onPress, buttonText, resourceType, colors } = this.props;

    let icon = "link";
    switch (resourceType) {
      case "offer":
        icon = "attach-money";
        break;
      case "download":
        icon = "get-app";
        break;
      case "call":
        icon = "call";
        break;
      case "link":
      default:
        icon = "link";
        break;
    }
    return (
      <Button
        onPress={onPress}
        style={{
          borderTopWidth: 1,
          borderTopStyle: "solid",
          borderTopColor: colors.border_color,
          padding: 15
        }}
      >
        <Row>
          <Icon
            icon={icon}
            size={18}
            color={colors.active_color}
            style={{ marginRight: 5 }}
          />
          <Copy style={{ color: colors.active_color, flex: 1 }}>
            {buttonText}
          </Copy>
        </Row>
      </Button>
    );
  }
}

export default Resource;
